import script from "./Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Edit.vue?vue&type=script&setup=true&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=414a6cb5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414a6cb5"]])

export default __exports__